import { chain, pick, uniq } from 'ramda';
import { AnyObject, MapOfTrackables, Trackable, TrackingScopes } from './types';

export type LocatorFn =
  | ((scopes: TrackingScopes | AnyObject, eventName: string) => Trackable | undefined)
  | ((scopes: TrackingScopes | AnyObject) => Trackable | undefined);
export type Locator = string | LocatorFn;
export interface ListPropertyMap {
  [key: string]: Locator[];
}
export interface ListLocator {
  listAt: Locator[];
  properties: ListPropertyMap;
}

export function keysFrom<T>(x: (keyof T)[]) {
  return x;
}

export class Dictionary<
  TEventNames extends string,
  TGroupNames extends string,
  TPropertyNames extends string
> {
  private events: { [TKey in TEventNames]: TGroupNames[] };
  private groups: { [TKey in TGroupNames]: TPropertyNames[] };
  private definitions: { [TKey in TPropertyNames]: (Locator | ListLocator)[] };
  private appendToEveryEvent?: MapOfTrackables;
  constructor(
    events: { [TKey in TEventNames]: TGroupNames[] },
    groups: { [TKey in TGroupNames]: TPropertyNames[] },
    definitions: { [TKey in TPropertyNames]: (Locator | ListLocator)[] },
    appendToEveryEvent?: MapOfTrackables
  ) {
    this.events = events;
    this.groups = groups;
    this.definitions = definitions;
    this.appendToEveryEvent = appendToEveryEvent;
    this.appendToEveryEvent;
  }
  getDefinitionsForEvent(event: TEventNames) {
    const requestedGroups = this.events[event];
    const propertyNames = uniq(chain((group: TGroupNames) => this.groups[group], requestedGroups));
    return pick(propertyNames, this.definitions);
  }
  getPropsToAppendToEveryEvent() {
    return this.appendToEveryEvent || {};
  }
  toString() {
    return Object.keys(this.events).join('|');
  }
}
